import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ITradePostPurchase } from "../interface/trade/post-purchase/ITradePostPurchase";
import { generateQueryString } from "src/util/helper";
import { ITradePostPurchaseGetResponse } from "src/services/interface/trade/post-purchase/response/ITradePostPurchaseGetResponse";
import { IActivatePricingDisbursementRequest } from "../interface/trade/post-purchase/request/IActivatePricingDisbursementRequest";
import { ILegalProcessMonitoring } from "../interface/LegalProcessMonitoring/ILegalProcessMonitoring";
import { saveByteArray } from "src/util/saveByteArray";
import IGenericDateRange from "../queryStrings/IQueryLegalProcessMovementsBasicInfo";

enum TradePostPurchaseServiceEnum {
  activatePricingDisbursement = "/activate-pricing-disbursement",
  putFinanceKeys = "/finance-keys",
  putFundingKeys = "/funding-keys",
  get = "/",
  getHistory = "/history?",
  saveUpdate = "/",
  getMovementsHistory = "/get-movements-history/",
  exportTradeMovements = "/export-trade-movements?"
}

export default class TradePostPurchaseService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/post-purchase");
  }

  public getAll = (): Promise<ITradePostPurchase[]> => this.GET(TradePostPurchaseServiceEnum.get);
  public getByIdTrade = (idTrade: number): Promise<ITradePostPurchase> => this.GET(`${TradePostPurchaseServiceEnum.get}${idTrade}`);
  public getPostPuchaseHistoryByIdTrade = (idTrade: number): Promise<ITradePostPurchase[]> =>
    this.GET(`${TradePostPurchaseServiceEnum.getHistory}${generateQueryString({ idTrade })}`);
  public putFinanceKeys = (trade): Promise<ITradePostPurchase> => this.PUT(TradePostPurchaseServiceEnum.putFinanceKeys, trade);
  public putFundingKeys = (trade): Promise<ITradePostPurchase> => this.PUT(TradePostPurchaseServiceEnum.putFundingKeys, trade);

  public saveUpdatePostPurchase = (request: ITradePostPurchaseGetResponse): Promise<ITradePostPurchase> => this.PUT(TradePostPurchaseServiceEnum.saveUpdate, request);

  public activatePricingDisbursement = (request: IActivatePricingDisbursementRequest): Promise<void> => this.PUT(TradePostPurchaseServiceEnum.activatePricingDisbursement, request)

  public getMovementsHistory = (processId: string): Promise<ILegalProcessMonitoring> => this.GET(`${TradePostPurchaseServiceEnum.getMovementsHistory}${processId}`);
  public exportTradeMovements = async (queryString: IGenericDateRange) => {
    const data = await this.GET(`${TradePostPurchaseServiceEnum.exportTradeMovements}${generateQueryString(queryString)}`, "blob")
    saveByteArray("TradeMovements.xlsx", data);
    return data;
  }
}
